export default __webpack_public_path__ + "static/media/icon-linkedin.8acc311b.svg";